import React from "react";
import ReactDOM from "react-dom";
import IndexComponent from "./components/index.component";
import "@progress/kendo-theme-default/dist/all.css";
import "./eticket-theme.css";
import "./index.css";
import "./i18n";
import { GlobalProvider } from "./GlobalState";

const FullApp = () => {
  return (<GlobalProvider>
    <IndexComponent />
  </GlobalProvider>)
};
ReactDOM.render(<FullApp />, document.getElementById("root"));
